import { ReactElement, SVGProps } from 'react'
export const SvgOk = (props: SVGProps<SVGSVGElement>): ReactElement => (
  <svg width={32} height={32} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#ok_svg__a)">
      <path
        d="M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16Z"
        fill="#F96200"
      />
      <g clipPath="url(#ok_svg__b)">
        <path
          d="M17.948 20.231a9.08 9.08 0 0 0 2.8-1.16 1.411 1.411 0 0 0-1.503-2.388 6.127 6.127 0 0 1-6.49 0 1.412 1.412 0 0 0-1.944.437v.003a1.41 1.41 0 0 0 .441 1.944l.003.003c.86.541 1.804.933 2.795 1.158l-2.695 2.694a1.396 1.396 0 0 0-.021 1.973l.024.024c.268.275.63.412.99.412.363 0 .724-.137.99-.412l2.663-2.647 2.646 2.65a1.416 1.416 0 0 0 1.996-.037 1.41 1.41 0 0 0 0-1.96l-2.695-2.694ZM16 16.301a4.821 4.821 0 0 0 4.818-4.817A4.826 4.826 0 0 0 16 6.666a4.826 4.826 0 0 0-4.818 4.818A4.824 4.824 0 0 0 16 16.304V16.3Zm0-6.81a1.994 1.994 0 1 1-1.41.584A2.006 2.006 0 0 1 16 9.489v.003Z"
          fill="#fff"
        />
      </g>
    </g>
    <defs>
      <clipPath id="ok_svg__a">
        <path fill="#fff" d="M0 0h32v32H0z" />
      </clipPath>
      <clipPath id="ok_svg__b">
        <path fill="#fff" transform="translate(6.667 6.666)" d="M0 0h18.667v18.667H0z" />
      </clipPath>
    </defs>
  </svg>
)
